import React, { useEffect } from 'react';
import { Select } from 'antd';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import {fetchAccountsGroups} from "../../Reducers/accounts";

function GroupSelector({ className, value, onChange, mode }) {
  const groups = useSelector((state) => state.accounts.accountsGroups.payload, shallowEqual);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!groups) {
      dispatch(fetchAccountsGroups());
    }
  }, []);

  return (
    <Select
      mode={mode}
      className={className}
      value={value}
      onChange={onChange}
      style={{ width: '100%' }}
      allowClear
    >
      {groups && groups.map(group => <Select.Option key={group} value={group}>{group}</Select.Option>)}
    </Select>);
}

export default GroupSelector;
